<template>
    <div>
     
        <div class="">
            <div class="product-item-warp ">
                <div class="row">
                    <div class="col-12 col-md-6 p-3 " v-for="item in products" :key="item.id" >
                        <div class="product-hover"  @click.prevent="moreInfo(item.id)">
                            <div class="product-hover-content content-between">
                                <div>
                                    <div class="product-name">
                                       <a>{{ item.title }}
                                        </a>
                                    </div>
                                    <div class="product-subname">
                                        <a>{{ item.description }}</a>
                                    </div>
                                    <div class="product-price">
                                        <span class="light">{{ item.price | currency }}</span>
                                    </div>
                                </div>
                            </div>
                            <img :src="`${ item.imageUrl }`" class="img-fluid" alt="">
                            <div class=" text-muted border-0  row no-gutters">
                             <div class="col-12 py-2">
                             <div class=" text-left text-primary" style="font-size:20px;font-weight:bold;">{{item.title}}</div>
                            </div>
                        <div class="col-12">
                            <div class=" text-left text-primary">
                             原價
                            <del>{{item.origin_price|currency}}</del>
                            </div>
                        <div class=" text-left text-primary">特價 {{item.price|currency}}</div>
                    </div>
            </div>
                        </div>
                       
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
export default {
props: ['products'],
 data() {
    return {
    
       status: {
         loadingItem:'',
      },
   
   
    };
  },
methods:{
      addtoCart(id, qty = 1) {
      const vm = this;
      const url = `${process.env.APIPATH}/api/${process.env.CUSTOMPATH}/cart`;
      vm.status.loadingItem = id;
      const cart = {    
        product_id: id,
        qty,
      };
      this.$http.post(url, { data: cart  }).then((response) => {
        console.log("已加入購物車",response);
        vm.status.loadingItem = '';
      });
    },
     moreInfo(id) {
      this.$router.push(`/product/${id}`);
      $(window).scrollTop(0);
    },
}
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/Products.vue